export module Formatters {
    export const Currency = new Intl.NumberFormat('et-EE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0
    })
}
